import { gql } from "@apollo/client";

export default gql`
  mutation sendBatch($paymentBatchId: Int!) {
    sendBatch(paymentBatchId: $paymentBatchId) {
      id
    }
  }
`;
